<template>
    <div class="fiscan-track" id="fiscan-track" v-if="value" ref="fiscanTrack">
        <header class="paper-header">
            <img class="logo" src="../../assets/images/common/nav_logo.png" alt="">
            <h1 class="paper-title">
                <el-tag class="type" size="mini">{{paperFormName}}</el-tag>
                <span v-if="paperInfo.title">{{ paperInfo.title }}</span>
                <span v-else-if="type==='practice'">职鉴走图练习</span>
            </h1>
            <div class="current-topic-info">
                <div class="clock" v-if="isExam">
                    <i class="nucfont inuc-clock"></i>
                    <span class="left-time">{{$t('exam.loading')}}</span>
                </div>
                <div class="topic-number">
                    <span><i>{{currentNumber}}</i> / {{topics.length}}</span>
                </div>
            </div>
            <el-button class="btn-close" @click="closeFn" type="danger" size="small" round><i class="nucfont inuc-close"></i>
            </el-button>
        </header>

        <section class="paper-container">
            <div class="paper-main">
                <ul class="image-list" id="image-list-ul">
                    <li class="image-item" v-for="(item, index) in slideList" :key="item.id" :index="item.index">
                        <div class="image-title">
                            <h3 class="title">{{item.index}}、{{item.image.productName}}</h3>
                        </div>

                        <div class="xray-image-wrap"
                             :class="{'mark-border': paperInfo.form===1 && responseObj[item.id]['isPass']===false}"
                        >
                            <img
                                ref="xrayImage"
                                class="xray-image"
                                @click="addMark(item.id, $event)"
                                @dblclick="markImage(item.id)"
                                :src="item.urls[currentOperateType]"
                                :style="{'width': item.width+'px', 'maxHeight': item.maxHeight+'px'}"
                                alt="image"
                            />

                            <ul class="mark-record-list" v-if="responseObj[item.id]['tags']">
                                <li class="mark-record"
                                    v-for="(tag, i) in responseObj[item.id]['tags']"
                                    @click="delMark(item.id, i)"
                                    :key="tag"
                                    :style="{
                                                top: tag.y*100+'%',
                                                left: tag.x*100+'%',
                                                transform: 'translate(-14px, -14px)',
                                            }">

                                    <div class="tooltip sign-tip right">
                                        <div class="tooltip-arrow"></div>
                                        <div class="tooltip-inner" v-if="tag.tagName">
                                            {{ tag.tagName }}
                                        </div>
                                        <div class="tooltip-inner tooltip-inner-mark" v-else>
                                            <i class="nucfont inuc-close-line"></i>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="space-wrap" v-if="spaceWrap">
                        <div class="space-box">
                            <div class="desc-wrap">
                                <div class="desc-item">
                                    <h3>当前模式：</h3>
                                    <div class="desc-item-content"><el-tag class="type" size="mini" effect="dark">{{paperFormName}}</el-tag></div>
                                </div>
                                <div class="desc-item">
                                    <h3>操作说明：</h3>
                                    <div class="desc-item-content">
                                        <template v-if="paperInfo.form === 1">
                                            <p>通过<el-tag size="mini">双击</el-tag>对可疑包裹进行标记，再次<el-tag size="mini">双击</el-tag>取消标记</p>
                                        </template>
                                        <template v-if="paperInfo.form === 2">
                                            <p>按下停止键后，<el-tag size="mini">左键点击</el-tag>违禁品位置进行标记。</p>
                                            <p>请注意违禁品数量可能不只一件。</p>
                                        </template>
                                        <template v-if="paperInfo.form === 3">
                                            <p>按下停止键后，<el-tag size="mini">左键点击</el-tag>违禁品位置进行标记，并选择违禁品类型。</p>
                                            <p>请注意违禁品数量可能不只一件。</p>
                                        </template>
                                    </div>
                                </div>
                                <div class="desc-item">
                                    <h3>走图说明：</h3>
                                    <div class="desc-item-content">
                                        <p>1、<el-tag size="mini">space</el-tag>空格键可以切换走图的开始和暂停</p>
                                        <p>2、作答完毕后，点击右下角「提交」按钮进行交卷</p>
                                        <p></p>
                                    </div>
                                </div>
                            </div>

                            <div class="loading-wrap">
                                <div class="btn-start-wrap" key="ready">
                                    <el-button @click="startRun" type="success"><i class="nucfont inuc-continue"></i>开始</el-button>
                                </div>
                                <p class="load-text">请点击「开始」按钮</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </section>

        <footer class="paper-footer">
            <div class="paper-info">
                <ul>
<!--                    <li>-->
<!--                        <h5>总题数：</h5>-->
<!--                        <p><b>{{ topics.length }}</b> {{ $t('exam.question') }}</p>-->
<!--                    </li>-->
                    <li v-if="paperInfo.totalScore">
                        <h5>{{ $t('paper.totalScore') }}：</h5>
                        <p><b>{{ paperInfo.totalScore }}</b> {{ $t('paper.points') }}</p>
                    </li>
                    <li v-if="paperInfo.score">
                        <h5>{{ $t('exam.score') }}：</h5>
                        <p><b>{{ paperInfo.score }}</b> {{ $t('paper.points') }}</p>
                    </li>
                    <li v-if="paperInfo.passScore">
                        <h5>{{ $t('count.passScore') }}：</h5>
                        <p><b>{{ paperInfo.passScore }}</b> {{ $t('paper.points') }}</p>
                    </li>
                    <li v-if="paperInfo.totalSeconds">
                        <h5>{{ $t('exam.period') }}：</h5>
                        <p><b>{{ Math.floor(paperInfo.totalSeconds / 60) }}</b> {{ $t('exam.min') }}</p>
                    </li>
                    <li v-if="paperInfo.form">
                        <h5>考试模式：</h5>
                        <p>
                            <b>{{ paperFormName }}</b>
                        </p>
                    </li>
                </ul>
            </div>

            <div class="image-operate-wrap">
                <ul class="image-operate">
                    <li class="operate-item"
                        v-for="(item, index) in imageOperate"
                        :class="[item.className, {'active': item.type === currentOperateType}]"
                        @click="operateClick(item.type)"
                        :key="'opr'+index"
                        :title="item.name + (item.keyboard ? `，快捷键：${item.keyboard}`:'') ">
                    </li>
                </ul>
                <ul class="image-operate">
                    <li class="run-item">
                        <i class="icon-speed nucfont inuc-dashboard2"></i>
                        <el-radio-group v-model="config.speed" size="mini" @click.native="radioAutoBlur">
                            <el-radio-button :label="2" title="正常速度">1</el-radio-button>
                            <el-radio-button :label="3" title="1.5倍速">1.5</el-radio-button>
                            <el-radio-button :label="4" title="2倍速">2</el-radio-button>
                            <el-radio-button :label="6" title="3倍速">3</el-radio-button>
                        </el-radio-group>
                    </li>
<!--                    <li class="run-item" @click="changeDirection()">-->
<!--                        <i v-if="runForward" class="icon-run nucfont inuc-arrow-right-circle" title="反向，快捷键：right"></i>-->
<!--                        <i v-else class="icon-run nucfont inuc-arrow-left-circle" title="正向，快捷键：left"></i>-->
<!--                    </li>-->
                    <li class="run-item" @click="changeDirection()">
                        <i v-if="runForward" class="icon-direction run-backward" title="反向，快捷键：right"></i>
                        <i v-else class="icon-direction  run-forward" title="正向，快捷键：left"></i>
                    </li>
                    <li class="run-item" @click="changeRun">
                        <i v-if="runStatus===0" class="icon-run nucfont inuc-play-circle-fill" title="开始，快捷键：space"></i>
                        <i v-else class="icon-run nucfont inuc-pause-circle-fill" title="暂停，快捷键：space"></i>
                    </li>
<!--                    <li class="run-item" @click="changeRun">-->
<!--                        <i v-if="runStatus===0" class="icon-direction run-start" title="开始，快捷键：space"></i>-->
<!--                        <i v-else class="icon-direction run-stop" title="暂停，快捷键：space"></i>-->
<!--                    </li>-->
                </ul>
            </div>

            <el-button class="btn-submit" @click="toSubmit" type="primary">提交</el-button>
        </footer>

        <div class="fullscreen-wrapper" v-if="loading">
            <div class="loading-wrap">
                <div class="sk-grid">
                    <div class="sk-grid-cube" v-for="n in 9"></div>
                </div>
                <p class="load-text">{{ $t('stu.loadingExamTip') }}</p>
            </div>
        </div>

        <fiscan-paper-result
            v-model="showResult"
            :id="resultID"
            :type="type"
            @close-result="onResultClose"
        />

        <!-- 类型选择弹框 -->
        <fiscan-kp-selector
            v-model="kpSelector"
            @submit="submitTagKp"
        />

        <!-- 消息弹框 -->
        <!-- 因为对页面进行了全屏，所以不能直接用加在body上的confirm组件 -->
        <el-dialog
            custom-class="modal-message"
            :visible.sync="showModal"
            top="30vh"
            width="450px"
            :title="$t('m.tip')"
            :modal-append-to-body="false"
            :close-on-click-modal="false"
        >
            <span><i class="icon-warn el-icon-warning"></i>{{$t('m.submitPaper')}}</span>
            <template #footer>
              <span class="dialog-footer">
                <el-button @click="cancelSubmitPaper" size="small">取消</el-button>
                <el-button type="primary" @click="submitPaper" size="small">确定</el-button>
              </span>
            </template>
        </el-dialog>

    </div>
</template>

<script>
/**
 * todo:
 * 、单个图片的放大缩小查看功能
 * 、图片加载失败的处理
 * 、最终优化
 */
import {screenfull, isEmpty, CountDown, Storage} from "@/utils";
import {FISCAN_OPERATE} from "@/config/constant";
import FiscanPaperResult from "./FiscanPaperResult";
import FiscanKpSelector from "./FiscanKpSelector";

export default {
    components: {
        FiscanPaperResult,
        FiscanKpSelector
    },

    props: {
        // v-model
        value: {
            type: Boolean,
            default: false
        },
        // 接口返回的试卷数据
        data: {
            type: Object,
            required: true
        },
        /**
         * 试卷类型 {String}
         * 考试：exam
         * 模拟考试：mockExam
         * 练习：practice
         **/
        type: {
            type: String,
            required: true
        },
        // 是否是一个新的补考试卷，是的话不取本地缓存数据
        isResitPaperClean: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            topics: [],
            responseObj: {}, // key=>value 形式的作答数据，key为id，便于数据操作
            slideList: [],
            imageOperate: FISCAN_OPERATE,
            currentOperateType: 0,

            loading: true,
            animationId: null,
            spaceWrap: true,
            runStatus: 0,    // 0暂停，1开始
            runForward: true, // 是否正向
            currentNumber: 1,
            config: {
                speed: 2,      // 走图的速度，每帧走几个px
                slideNum: 5,   // slide的数量
                savedTime: 30, // 自动保存间隔时间
            },

            kpSelector: false,
            showResult: false,
            showModal: false,
            resultID: '',
        }
    },

    computed: {
        paperInfo() {
            if (this.data?.paper) {
                const paperInfo = {}
                Object.assign(paperInfo, this.data, this.data.paper)
                delete paperInfo.paper
                console.log('paperInfo', paperInfo)
                return paperInfo
            }

            console.log('paperInfo', this.data)
            return this.data || {}
        },
        // 用于保存答案的 localStorage key
        localKey() {
            if (this.type === 'exam') {
                return `fiscan_exam_${this.paperInfo.testID}`
            } else if (this.type === 'mockExam') {
                return `fiscan_mock_${this.paperInfo.guid}`
            }
        },
        paperFormName() {
            const formMap = {
                1: this.$t('stu.quickJudge'),
                2: this.$t('stu.markLocation'),
                3: this.$t('stu.markLocationAndJudge')
            }

            if (this.paperInfo.form) {
                return formMap[this.paperInfo.form]
            }

            return ''
        },
        // 考试 = 考试 || 模拟考试
        isExam() {
            return this.type === 'exam' || this.type === 'mockExam'
        },
    },

    watch: {
        value: {
            handler(v) {
                if (v) {
                    this.onShow()
                }
            },
            immediate: true
        },
        data(value) {
            if (!isEmpty(value)) {
                this.onPaperData(value)
            }
        },
    },

    methods: {
        onShow() {
            //this.fullScreen()
            console.log('show')

            // 初始化
            this.loading = true
            this.reset()
            this.initEvents()
        },

        onPaperData(data) {
            // 填充作答数据
            this.fillResponse(data)

            // 加载考题数据
            this.fillTopics(data)

            this.loadImages()
        },

        fillResponse(data) {
            let response = []

            if (this.type === 'exam' || this.type === 'mockExam') {
                response = data.records
            }

            if (this.type === 'practice') {
                response = data.response
            }

            // 加载本地数据
            const localResponse = Storage.get(this.localKey)
            if (this.isExam && localResponse) {
                if (!this.isResitPaperClean) {
                    response = localResponse

                    // 恢复现场时，往前倒两道题，比如该做第5题，第一道题就为第3题
                    const index = response.findIndex(item => item.isPass === null)
                    if (index > -1) {
                        this.currentNumber = index - 1 > 0 ? index - 1: 1
                    } else {
                        this.currentNumber = response.length - 2
                    }

                } else {
                    // 每次点击补考按钮，都是一个新的考卷
                    Storage.remove(this.localKey)
                }
            }

            this.responseObj = {}
            response.forEach(item => {
                const id = item.packageId || item.topicID
                this.responseObj[id] = {...item}
            })
        },

        fillTopics(data) {
            if (this.type === 'exam' || this.type === 'mockExam') {
                this.topics = data.paper?.relationship.map(item => item.topic)
            }

            if (this.type === 'practice') {
                this.topics = data.fiscan
            }

            // 额外添加一些参数
            this.topics.forEach(item => {
                item.urls = {}
                item.image.operations.forEach(op => {
                    item.urls[op.type] = op.url
                })
            })
        },

        loadImages() {
            // 先加载前10张图
            let promiseAll = []
            let img = []

            this.topics.forEach((item, i) => {
                item.maxHeight = $('.image-list').height()

                // 加载前10张图
                if (i < 10) {
                    promiseAll[i] = new Promise((resolve, reject) => {
                        img[i] = new Image()
                        img[i].src = item.url
                        img[i].onload = function() {
                            //console.log(`第${i}张加载完成`)
                            item.width = img[i].width
                            item.height = img[i].height
                            resolve(img[i])
                        }
                        img[i].onerror = function(err) {
                            // todo: 图片出错处理
                        }
                    })
                } else {
                    img[i] = new Image()
                    img[i].src = item.url
                    img[i].onload = function() {
                        //console.log(`第${i}张加载完成`)
                        item.width = img[i].width
                        item.height = img[i].height
                    }
                }
            })

            // 前10张图加载完毕后进行主流程
            Promise.all(promiseAll).then((img) => {
                console.log('初始图像加载完毕')
                this.loading = false
                this.startExam()
            })
        },

        /**
         * 初始图像加载完毕，开始走图考试
         */
        startExam() {
            this.slideList = [...this.topics].map((item, index) => {
                item.index = index + 1
                return item
            })

            // 5,4,3,2,1
            this.slideList = this.slideList.slice(this.currentNumber-1, this.currentNumber-1+this.config.slideNum).reverse()

            this.$nextTick(() => {
                // 缓存dom变量
                this.$ul = $('.image-list')
                this.ul = this.$ul[0]
                this.ulWidth = this.$ul.width()
                this.$spaceWrap = $('.space-wrap')

                // console.log('视口宽度', this.ulWidth)

                // 平移画布
                this.$ul.scrollLeft(this.ul.scrollWidth - this.ulWidth)

                // 开始计时
                !this.cd && this.initCountDown()
            })
        },

        startRun(e) {
            e && e.target.blur()

            this.runForward = true
            this.runTrack()

            if (this.currentNumber > 1) {
                this.spaceWrap = false
            }
        },

        stopRun() {
            this.runStatus = 0
            window.cancelAnimationFrame(this.animationId)
        },

        changeRun() {
            if (this.runStatus === 0) {
                this.runTrack()
            } else if (this.runStatus === 1) {
                this.stopRun()
            }
        },

        changeDirection(isForward) {
            if (isForward !== undefined) {
                this.runForward = isForward
            } else {
                this.runForward = !this.runForward
            }
        },

        // 走图逻辑
        runTrack() {
            // 方法一
            this.animationId && window.cancelAnimationFrame(this.animationId)
            this.runStatus = 1
            this.animationId = window.requestAnimationFrame(this.handleTrackFrame)

            // 方法二
            // this.fps = 60
            // this.now = 0
            // this.then = Date.now()
            // this.interval = 1000/this.fps
            // this.delta = 0
            //
            // this.animationId && window.cancelAnimationFrame(this.animationId)
            // this.runStatus = 1
            // this.tick()
            // this.method2 = true
        },

        tick() {
            this.animationId = requestAnimationFrame(this.tick)
            this.now = Date.now()
            this.delta = this.now - this.then
            if (this.delta > this.interval) {
                // 这里不能简单then=now，否则还会出现上边简单做法的细微时间差问题。例如fps=10，每帧100ms，而现在每16ms（60fps）执行一次draw。16*7=112>100，需要7次才实际绘制一次。这个情况下，实际10帧需要112*10=1120ms>1000ms才绘制完成。
                this.then = this.now - (this.delta % this.interval)
                this.handleTrackFrame() // ... Code for Drawing the Frame ...
            }
        },

        /**
         * 每一帧的处理，该方法被requestAnimationFrame循环调用
         * 该方法用于实现虚拟slide及无缝走图
         */
        handleTrackFrame() {
            // let s = Math.ceil(this.$ul.scrollLeft())
            // this.$ul.scrollLeft(s - 6)
            // this.animationId = window.requestAnimationFrame(this.handleTrackFrame)
            // return

            //let range = this.runForward ? -this.config.speed : this.config.speed
            const scrollLeft = Math.ceil(this.$ul.scrollLeft())
            const itemCount = this.$ul.find('.image-item').length

            // 正向
            if (this.runForward) {
                let range = -this.config.speed

                // 当 spaceWrap 移出视口后即隐藏
                if (this.spaceWrap) {
                    const spaceWrapLeft = this.$spaceWrap.offset().left
                    if (spaceWrapLeft > this.ulWidth) {
                        this.spaceWrap = false
                    }
                }

                // 每当第二个item进入可视区域时，在头部添加新的item
                // fixme: 用更高效的写法
                const firstIndex = this.$ul.find('.image-item').eq(0).attr('index') - 0
                if (firstIndex < this.topics.length) {
                    const $item2 = this.$ul.find(`.image-item[index=${firstIndex-1}]`)
                    if ($item2.offset().left + $item2.innerWidth() >= 0) {
                        this.slideList.unshift(this.topics[firstIndex])
                        this.$nextTick(() => {
                            const $itemNew = this.$ul.find(`.image-item`).eq(0)
                            this.$ul.scrollLeft(scrollLeft + $itemNew.innerWidth())
                            range = 0
                        })
                    }
                }

                // 每当最后一个item离开可视区域后，移除
                const $itemLast = this.$ul.find(`.image-item`).eq(-1)
                if (itemCount >= this.config.slideNum &&
                    $itemLast.offset().left > this.ulWidth) {
                    this.slideList.pop()
                }

                // 进行偏移
                this.$ul.scrollLeft(scrollLeft + range)

                // 判断是否到头了
                if (scrollLeft + range >= 0) {
                    if (!this.method2) {
                        this.animationId = window.requestAnimationFrame(this.handleTrackFrame)
                    }
                } else {
                    this.stopRun()
                }

                // 反向
            } else {
                let range = this.config.speed


                // 倒数第二个item进入可视区域时，在底部添加新的item
                const lastIndex = this.$ul.find('.image-item').eq(-1).attr('index') - 0
                if (lastIndex > 1) {
                    const $itemLast2 = this.$ul.find(`.image-item[index=${lastIndex+1}]`)
                    if ($itemLast2.offset().left < this.ulWidth) {
                        this.slideList.push(this.topics[lastIndex-2])
                    }
                }

                // 每当第一个item离开可视区域后，移除
                const $itemFirst = this.$ul.find(`.image-item`).eq(0)
                const itemFirstWidth = $itemFirst.innerWidth()

                if (itemCount >= this.config.slideNum &&
                    $itemFirst.offset().left + $itemFirst.innerWidth() < 0) {

                    this.slideList.shift()

                    this.$nextTick(() => {
                        this.$ul.scrollLeft(scrollLeft - itemFirstWidth)
                        range = 0
                    })
                }

                // 进行偏移
                this.$ul.scrollLeft(scrollLeft + range)

                // 判断是否到头了
                if (scrollLeft + range <= this.ul.scrollWidth - this.ulWidth) {
                    if (!this.method2) {
                        this.animationId = window.requestAnimationFrame(this.handleTrackFrame)
                    }
                } else {
                    this.stopRun()
                }
            }

            this.handleCurrentImage()
        },

        /**
         * 在每一帧的回调中，处理走过的图，记录当前的题号和作答结果
         */
        handleCurrentImage() {
            if (this.runForward) {
                const $nextImage = this.$ul.find(`.image-item[index=${this.currentNumber+1}]`)

                if (this.currentNumber < this.topics.length) {
                    // 下一幅图像即将全部出现
                    if ($nextImage.offset()?.left > -20) {
                        // 记录默认的作答结果
                        this.recordResponseDefault()
                        // 序号变为下一张图的序号
                        this.currentNumber += 1
                    }
                    // 最后一题
                } else if (this.currentNumber === this.topics.length) {
                    this.recordResponseDefault()
                }

            } else if (this.currentNumber > 1) {
                const $lastImage = this.$ul.find(`.image-item[index=${this.currentNumber-1}]`)

                if ($lastImage.offset() && $lastImage.width() + $lastImage.offset().left - this.ulWidth < -20) {
                    this.recordResponseDefault()
                    this.currentNumber -= 1
                }
            }
        },

        // 记录默认作答结果：图走过去之后，如果没标记，则自动作答为「安全」
        recordResponseDefault() {
            const currentItemId = this.topics[this.currentNumber-1]['id']
            const currentResponse = this.responseObj[currentItemId]

            if (currentResponse.isPass === null) {
                this.markImage(currentItemId, true)
            }

            if (this.isExam) {
                this.savePaperOnLocal()
            }
        },

        // 标记图片为安全or危险
        markImage(id, isPass) {
            // 其他模式下禁止双击标记
            if (isPass === undefined && this.paperInfo.form !== 1) return

            const currentResponse = this.responseObj[id]

            if (isPass !== undefined) {
                currentResponse.isPass = isPass
            } else {
                currentResponse.isPass = !(currentResponse.isPass === null || currentResponse.isPass === true)
            }

            this.updateResponse(id, currentResponse)
        },

        addMark(id, e) {
            if (this.paperInfo.form === 1 || this.runStatus === 1) return

            const currentResponse = this.responseObj[id]

            // fixme 全屏无法显示
            if (currentResponse.tags?.length >= 10) {
                return this.$message.error('标框达到上限！')
            }

            const imgW = e.target.clientWidth
            const imgH = e.target.clientHeight
            const x = (e.offsetX / imgW).toFixed(2) - 0  // 框圆心距图片左边的比例（小数）
            const y = (e.offsetY / imgH).toFixed(2) - 0    // 框圆心距图片上边的比例（小数）

            if (this.paperInfo.form === 3) {
                this.kpSelector = true
                this.tempResponse = currentResponse
                this.tempImageId = id
                this.currentX = x
                this.currentY = y
            } else {
                currentResponse.tags.push({x, y})
                this.markImage(id, false)
                this.updateResponse(id, currentResponse)
            }
        },
        delMark(id, index) {
            if (this.paperInfo.form === 1 || this.runStatus === 1) return

            const currentResponse = this.responseObj[id]
            currentResponse.tags.splice(index, 1)
            this.updateResponse(id, currentResponse)
        },
        submitTagKp({id, name}) {
            if (!id) return

            const currentResponse = this.tempResponse
            const tag = {
                x: this.currentX,
                y: this.currentY,
                tagKp: id,
                tagName: name
            }

            currentResponse.tags.push(tag)
            this.markImage(this.tempImageId, false)
            this.updateResponse(this.tempImageId, currentResponse)
            this.kpSelector = false
        },
        /**
         * 在模板中强行更新 responseObj
         * 因为定义 responseObj 的时候是空的对象，所以里面的key均不具有响应性
         */
        updateResponse(id, newResponse) {
            this.responseObj = {
                ...this.responseObj,
                [id]: newResponse
            }
            if (this.isExam) {
                this.savePaperOnLocal()
            }
        },

        initCountDown() {
            let duration = this.paperInfo.remainSeconds;

            if (!duration) return

            let savedTime = new Date().getTime();

            // 多少秒存一次
            const frequency = this.config.savedTime

            this.cd = new CountDown(duration*1000, (time) => {
                time = time/1000;
                let minute = Math.floor(time / 60);
                let second = time % 60;

                $('.left-time').text(`${minute} ${this.$t('count.min')} ${second} ${this.$t('count.s')}`);

                // 定时保存用户数据到server
                if (new Date().getTime() - savedTime >= frequency * 1000) {
                    savedTime = new Date().getTime();
                    this.savePaperOnServer();
                }
            }, () => {
                this.submitPaper();
            })
        },

        savePaperOnServer() {
            const response = this.getRealResponse()

            if (this.type === 'mockExam') {
                this.$api.saveFiscanMockExam(this.paperInfo.testID, this.paperInfo.guid, response)
            } else {
                this.$api.saveFiscanExam(this.paperInfo.testID, response)
            }
        },
        savePaperOnLocal() {
            const response = this.getRealResponse()
            Storage.set(this.localKey, response)
        },
        getRealResponse() {
            let response = []
            for (const key in this.responseObj) {
                response.push(this.responseObj[key])
            }
            return response
        },

        toSubmit() {
            this.showModal = true
            this.stopRun()
        },
        cancelSubmitPaper() {
            this.showModal = false
            if (!this.spaceWrap) {
                this.runTrack()
            }
        },
        async submitPaper() {
            this.showModal = false

            const response = this.getRealResponse()

            if (this.type === 'practice') {
                const res = await this.$api.submitFiscanPractice(this.paperInfo.guid, this.paperInfo.form, response)
                this.resultID = res.package
                this.reviewID = this.paperInfo.guid
            }

            if (this.type === 'exam') {
                await this.$api.submitFiscanExam(this.paperInfo.testID, response)
                this.reviewID = this.resultID = this.paperInfo.testID
                this.cd.clear()
                Storage.remove(this.localKey)
            }

            if (this.type === 'mockExam') {
                const res = await this.$api.submitFiscanMockExam(this.paperInfo.testID, this.paperInfo.guid, response)
                this.reviewID = this.resultID = res.package
                this.cd.clear()
                Storage.remove(this.localKey)
            }

            this.showResult = true
        },

        onResultClose(isReview) {
            if (isReview) {
                this.$emit('review',this.reviewID)
            } else {
                this.closeFn()
            }
        },

        operateClick(type) {
            if (this.currentOperateType === type) {
                this.currentOperateType = 0
            } else {
                this.currentOperateType = type
            }
        },

        fullScreen() {
            this.$nextTick(() => {
                if (!screenfull.isFull()) {
                    console.log(this.$refs.fiscanTrack)
                    screenfull.request(this.$refs.fiscanTrack)
                }
            })
        },
        exitFullScreen() {
            if (screenfull.isFull()) {
                screenfull.exit()
            }
        },

        initEvents() {
            $(document).on('keydown.paper', e => {
                // 显示知识点弹框的时候不响应按键
                if (this.kpSelector) return

                // 空格
                if (e.key === ' ') {
                    if (this.spaceWrap && this.runStatus === 0) {
                        this.startRun()
                    } else {
                        this.changeRun()
                    }
                }

                // 左箭头
                if (e.key === 'ArrowLeft') {
                    this.changeDirection(true)
                }

                // 右箭头
                if (e.key === 'ArrowRight') {
                    this.changeDirection(false)
                }

                // 图像操作按键
                const operationItem = this.imageOperate.find(item => item.keyboard === e.key || item.keyboard === e.key.toUpperCase())
                if (operationItem) {
                    this.operateClick(operationItem.type)
                    e.preventDefault()
                }
            })

            $(window).on('resize.track', e => {
                if (!screenfull.isFull()) {
                    this.closeFn()
                }
            })
        },

        // el-radio-group 点击后自动失去焦点，以免影响快捷键的响应
        radioAutoBlur(e) {
            const node = e.target
            if (node.nodeName.toLowerCase() === 'input') {
                node.blur()
            }
        },

        closeFn() {
            this.$emit('input', false)
            this.$emit('close')
            this.exitFullScreen()
            this.offEvents()
            this.reset()
        },

        reset() {
            Object.assign(this.$data, this.$options.data())
        },

        offEvents() {
            $(document).off('keydown.paper')
            $(window).off('resize.track')
            this.animationId && window.cancelAnimationFrame(this.animationId)
            if (this.cd) {
                this.cd.clear()
                this.cd = null
            }
        },
    },
}
</script>

<style lang="scss">
@import 'FiscanTrack';
</style>
